import React from 'react';
import './applicationsPageStyle.css';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/footer';
import ContentBlock from './../../components/contentBlock/contentBlock'
import H2Title from '../../components/text/h2Title/h2Title';

export default function ApplicationsPage() {
    
    const siteContent = useSetSiteLanguage();

    return (
        <>
            <Navbar data={siteContent?.navbar}/>

            <section className='applications-page__container'>
                <H2Title title={siteContent?.applicationsPage?.summary?.title} />

                <ContentBlock text={siteContent?.applicationsPage?.summary?.text} photo={siteContent?.applicationsPage?.summary?.photo} />

                <div className='applications-page__content-wrapper'>
                    {siteContent?.applicationsPage?.applications.map( (item, index) => (
                        <ContentBlock
                            title={item.title}
                            photo={item.photo}
                            text={item.text}
                            type={item.type}
                            key={index}/>
                    ))}
                </div>  
            </section>

            <Footer />
        </>
    );
}
